module.exports = fetch;


//////////////////
// WEBPACK FOOTER
// external "fetch"
// module id = 96
// module chunks = 0